import { render } from "./BlFormFieldMulticheckbox.vue?vue&type=template&id=56fce10f&scoped=true"
import script from "./BlFormFieldMulticheckbox.vue?vue&type=script&lang=js"
export * from "./BlFormFieldMulticheckbox.vue?vue&type=script&lang=js"

import "./BlFormFieldMulticheckbox.vue?vue&type=style&index=0&id=56fce10f&scoped=true&lang=css"

import exportComponent from "/tmp/6f278242-b890-433a-91e8-ee1cfc12c380/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fce10f"]])

export default __exports__